import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { COMMA, ENTER, V, X } from "@angular/cdk/keycodes";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/services/common.service";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DiffEditorModel,NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import {
  AuditUiCategory,
  buildAuditSearchText,
  classifyAuditRecord,
  getAvailableCategoryTabs,
  getDefaultSelectedCategory,
} from 'src/app/utils/audit-category.util';

declare const copyToClipboard: any;
export interface DiffContent {
  leftContent: string;
  rightContent: string;
}
@Component({
  selector: 'app-newaudit',
  templateUrl: './newaudit.component.html',
  styleUrls: ['./newaudit.component.scss']
})

export class NewauditComponent implements OnInit, OnDestroy {
  editorOptions={}
  classObjalertmain: string;
  StatusMessagedisplay: string;
  statusmessageMainflg: boolean;
  auditmodalheight: Number = 400;
  AuditDifference: any[] = [];
  @Input() inputDataInModalComponent: any;
  id: string = '';
  guid: string;
  context: string = '';
  usernamedisplay: string;
  type: string = '';
  auditdetaillist: any = [];
  title: string;
  audit: AuditValue[] = [];
  auditNew: AuditValue[] = [];
  inputdata: string = "";
  OutputData: string = "";
  formatType: string = "text/plain";
  key: string = ''
  value: string = ''
  showeditor: boolean
  Olddata: any = ''
  Newdata: any = ''
  formatType1: string = ''
  left: any = ''
  auditdetaillistbackup: any[] = []
  right: any = ''
  contentObservable: Subject<DiffContent> = new Subject<DiffContent>();
  contentObservable$: Observable<DiffContent> = this.contentObservable.asObservable();
  categoryTabs: AuditUiCategory[] = [];
  selectedCategory: AuditUiCategory = 'All Audits';
  searchText = '';
  description: string = 'Pipeline Config deactivated Successfully with configId 57540F20-1140-4BD6-81B4-6B9CE7B067A6_6F94F6E0-7C29-42DA-8C4B-A7E87BCEAE8B_Config'
  private destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private activeModal: NgbActiveModal,
    public ref: ChangeDetectorRef,
    private toastr: ToastrService,
  ) { }
  isselect: any = ''
formattype='text/plain';
  oldModel:DiffEditorModel={
    code:'',
    language: this.formattype
  }
  newModel:DiffEditorModel={
    code:'',
    language: this.formattype
  }
  diffOptions = {
    theme: "vs",
    language: this.formattype,
    readOnly: true,
    lineNumbers: true,
    wordWrap: 'on',
    renderSideBySide:true,
    scrollBeyondLastLine: false
  };
  ngOnInit() {
    this.id = this.inputDataInModalComponent.id;
    this.guid = this.inputDataInModalComponent.guid; // Route GUID for interface audits
    this.context = this.inputDataInModalComponent.context;
    this.getAuditDetails(this.id);
    this.service.timezoneChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.ref.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** UTC API AuditdDate → selected header timezone. */
  formatAuditDate(auditDate: string | null | undefined): string {
    if (!auditDate) {
      return '';
    }
    return this.service.formatDateTimeForDisplay(auditDate, 'MM/dd/yyyy HH:mm:ss');
  }
  async getAuditDetails(id: any) {
    this.ngxUiLoaderService.start();
    
    // Fetch primary audits (existing behavior)
    var apiname = "api/Audit/GetAuditDetails?id=" + id + "&context=" + this.context;
    let primaryAudits = await this.service.getapi(apiname) || [];
    
    // Fetch interface audits if guid is available and context is Pipeline
    let interfaceAudits: any[] = [];
    if (this.guid && this.context === 'Pipeline') {
      var interfaceApiName = "api/Audit/GetAuditDetails?id=" + this.guid + "&context=interface";
      interfaceAudits = await this.service.getapi(interfaceApiName) || [];
    }
    
    // Merge both audit lists
    this.auditdetaillist = [...(primaryAudits || []), ...(interfaceAudits || [])];
    
    // Sort by date (most recent first)
    this.auditdetaillist.sort((a, b) => {
      const dateA = new Date(a.AuditdDate).getTime();
      const dateB = new Date(b.AuditdDate).getTime();
      return dateB - dateA;
    });

    const resultset = this.auditdetaillist as any[];
    if (resultset.length == 0) {
      this.auditdetaillistbackup = [];
      this.categoryTabs = [];
      this.ngxUiLoaderService.stop();
    }
    else {
      resultset.forEach(data => {
        data.uiCategory = classifyAuditRecord(data);
        data._searchText = buildAuditSearchText(data);
      });

      resultset.forEach(data => {
        if (this.isApiConnectivityAuditDescription(data?.Description)) {
          this.parseApiConnectivityAuditEntry(data);
        } else if (this.isvalidjson(data.OldValue) && this.isvalidjson(data.NewValue) && this.context != 'Agent'&& this.context != 'Processor') {
          let jsonOldValue = JSON.parse(data.OldValue);
         
          this.getkeyvalue(jsonOldValue, 'audit');
          data.OldValue = [];
          data.OldValue = this.audit;

          let jsonNewValue = JSON.parse(data.NewValue);
         
          this.getkeyvalue(jsonNewValue, 'auditnew');
          data.NewValue = [];
          data.NewValue = this.auditNew;
        }
        else {
          let auditOld: AuditValue[] = [];
          if(data.OldValue.startsWith("{"))
          {
            data.OldValue=JSON.parse(data.OldValue);
            data.OldValue['datatype']='object';
            if(this.context == 'Processor' && data.OldValue['jsonconfig']!=null){
              data.OldValue['jsonconfig']=JSON.parse(JSON.parse(data.OldValue['jsonconfig']));
              data.OldValue['jsonconfig']=JSON.stringify(data.OldValue['jsonconfig'],null, 2);
            }
            if (data.OldValue['Password'] !== null || data.OldValue['Password'] !== undefined) {
              data.OldValue['Password'] = "********";
            }
            data.OldValue=JSON.stringify(data.OldValue);
            
          }
          else{
            data.OldValue=data.OldValue.toString();
          }
          let auditOldValue: AuditValue = {
            Key: '',
            Value: data.OldValue
          }
          auditOld.push(auditOldValue);
          data.OldValue = auditOld;

          let auditNew: AuditValue[] = [];
          if(data.NewValue.startsWith("{"))
          {
            data.NewValue=JSON.parse(data.NewValue);
            data.NewValue['datatype']='object';
            if(this.context == 'Processor' && data.NewValue['jsonconfig']!=null){
              data.NewValue['jsonconfig']=JSON.parse(data.NewValue['jsonconfig']);
              data.NewValue['jsonconfig']=JSON.stringify(data.NewValue['jsonconfig'],null, 2);
            }
            if (data.NewValue['Password'] !== null || data.NewValue['Password'] !== undefined) {
              data.NewValue['Password'] = "********";
            }
            data.NewValue=JSON.stringify(data.NewValue);
          }
          else{
            data.NewValue=data.NewValue.toString();
          }
          let auditNewValue: AuditValue = {
            Key: '',
            Value: data.NewValue
          }
          auditNew.push(auditNewValue);
          data.NewValue = auditNew;
        }
      })

      this.ngxUiLoaderService.stop();
      this.auditdetaillistbackup = resultset;
      this.refreshCategoryTabs();
      this.applyFilters();
    }
  }

  refreshCategoryTabs(): void {
    this.categoryTabs = getAvailableCategoryTabs(this.auditdetaillistbackup);
    if (!this.categoryTabs.includes(this.selectedCategory)) {
      this.selectedCategory = getDefaultSelectedCategory(this.categoryTabs);
    }
  }

  getCategoryCount(category: AuditUiCategory): number {
    if (!this.auditdetaillistbackup?.length) {
      return 0;
    }
    if (category === 'All Audits') {
      return this.auditdetaillistbackup.length;
    }
    return this.auditdetaillistbackup.filter(r => r.uiCategory === category).length;
  }

  onCategorySelect(category: AuditUiCategory): void {
    this.selectedCategory = category;
    this.applyFilters();
  }

  onSearchChange(): void {
    this.applyFilters();
  }

  clearFilters(): void {
    this.searchText = '';
    this.selectedCategory = getDefaultSelectedCategory(this.categoryTabs);
    this.applyFilters();
  }

  applyFilters(): void {
    let list = [...(this.auditdetaillistbackup || [])];

    if (this.selectedCategory !== 'All Audits') {
      list = list.filter(r => r.uiCategory === this.selectedCategory);
    }

    const query = this.searchText?.trim().toLowerCase();
    if (query) {
      list = list.filter(r => (r._searchText || '').includes(query));
    }

    this.auditdetaillist = list;
    this.isselect = '';

    if (list.length > 0) {
      this.getauditdiff(list[0], 0);
    } else {
      this.showeditor = false;
    }
  }
  getkeyvalue(data, type) {
    this.auditNew = [];
    this.audit = [];
    if (typeof data === "object") {
      for (let [key, value] of Object.entries(data)) {
        if (value != null) {
          if (typeof value === "object") {
            this.getkeyvalue(value, type);
          }
        }
        if (typeof value === 'string' || value == null) {
          let auditValue: AuditValue = {
            Key: [key].toString(),
            Value: [value].toString()
          }
          if (type == 'auditnew') {
            this.auditNew.push(auditValue);
          }
          else {
            this.audit.push(auditValue);
          }
        }
      }
    }
    if (typeof data === "object") {

    }
  }

  private isApiConnectivityAuditDescription(description: string): boolean {
    const d = (description || '').toLowerCase();
    return d.includes('api connectivity details added') || d.includes('api connectivity details updated');
  }

  private isApiConnectivityPasswordField(name: string): boolean {
    return (name || '').toLowerCase().endsWith('.auth.password');
  }

  private maskApiConnectivityAuditValue(name: string, value: string): string {
    if (this.isApiConnectivityPasswordField(name) && (value || '').trim() !== '') {
      return '******';
    }
    return value ?? '';
  }

  private parseApiConnectivityAuditEntry(data: any): void {
    const auditOld: AuditValue[] = [];
    const auditNew: AuditValue[] = [];

    if (this.isvalidjson(data?.OldValue)) {
      auditOld.push(...this.parseApiConnectivityAuditValue(data.OldValue, true));
    } else if ((data?.OldValue || '').toString().trim()) {
      const parsedOld = this.parseApiConnectivityUpdateText(data.OldValue.toString(), true);
      if (parsedOld.length > 0) {
        auditOld.push(...parsedOld);
      } else {
        auditOld.push({ Key: '', Value: data.OldValue.toString() });
      }
    }

    if (this.isvalidjson(data?.NewValue)) {
      auditNew.push(...this.parseApiConnectivityAuditValue(data.NewValue, true));
    } else if ((data?.NewValue || '').toString().trim()) {
      const parsed = this.parseApiConnectivityUpdateText(data.NewValue.toString(), true);
      if (parsed.length > 0) {
        auditNew.push(...parsed);
      } else {
        auditNew.push({ Key: '', Value: data.NewValue.toString() });
      }
    }

    data.OldValue = auditOld;
    data.NewValue = auditNew;
  }

  private parseApiConnectivityAuditValue(rawValue: string, maskPasswords: boolean): AuditValue[] {
    try {
      const parsed = JSON.parse(rawValue);
      if (!Array.isArray(parsed)) {
        return [];
      }
      return parsed
        .filter((row: any) => row && (row.Name || row.name))
        .map((row: any) => {
          const name = (row.Name || row.name || '').toString();
          const value = (row.Value ?? row.value ?? '').toString();
          return {
            Key: name,
            Value: maskPasswords ? this.maskApiConnectivityAuditValue(name, value) : value
          };
        });
    } catch {
      return [];
    }
  }

  private parseApiConnectivityUpdateText(rawValue: string, maskPasswords: boolean): AuditValue[] {
    const text = (rawValue || '').trim();
    if (!text) {
      return [];
    }
    const separatorIndex = text.indexOf(' : ');
    if (separatorIndex <= 0) {
      return [{ Key: '', Value: text }];
    }
    const name = text.substring(0, separatorIndex).trim();
    const value = text.substring(separatorIndex + 3).trim();
    return [{
      Key: name,
      Value: maskPasswords ? this.maskApiConnectivityAuditValue(name, value) : value
    }];
  }

  isvalidjson(stringvalue) {
    try {
      let output = JSON.parse(stringvalue);
      return true;

    } catch (error) {
      return false;
    }
  }
  copyToClip(event: any, message: any) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " copied", "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  close() {
    this.activeModal.close();
  }

  getauditdiff(audobj, i) {
    this.isselect = i
    this.ngxUiLoaderService.start();
    this.AuditDifference = audobj
    this.Olddata = ''
    this.Newdata = ''

    if (typeof this.AuditDifference['OldValue'] == 'string' || this.AuditDifference['OldValue'] == '') {
      this.Olddata = this.AuditDifference['OldValue'];
      this.formatType='text/plain'
    } else {
      let obj = {}
      this.AuditDifference['OldValue'].forEach(element => {
        if (element['Key'] == '' && element['Value'] == '') {

          this.Olddata = '';
        }
        else if (element['Key'] == '' && element['Value'] != '') {
          if (element['Value'].startsWith('{')) {
            this.constructobj(JSON.parse(element['Value']), 'old')
          }
          else {
            this.Olddata = element['Value'];
          }
        }
        else {
          for (let [key, value] of Object.entries(element)) {
            if ([key].toString() == 'Key') {
              this.key = [value].toString();
            }
            else {
              obj[this.key] = [value].toString();
            }
          }
          this.constructobj(obj, 'old');
          // this.Olddata=JSON.stringify(obj);
          // this.left=this.Olddata
        }
      });

    }
    if (typeof this.AuditDifference['NewValue'] == 'string' || this.AuditDifference['NewValue'] == '') {
      this.Newdata = this.AuditDifference['NewValue'];
    } else {
      let obj = {}
      this.AuditDifference['NewValue'].forEach(element => {
        if (element['Key'] == '' && element['Value'] == '') {

          this.Newdata = '';
        }
        else if (element['Key'] == '' && element['Value'] != '') {
          if (element['Value'].startsWith('{')) {
            this.constructobj(JSON.parse(element['Value']), 'new')
          }
          else {
            this.Newdata = element['Value'];
          }
        }
        else {
          for (let [key, value] of Object.entries(element)) {
            if ([key].toString() == 'Key') {
              this.key = [value].toString()
            }
            else {
              obj[this.key] = [value].toString();
            }
          }
          this.constructobj(obj, 'new');
          // this.Newdata=JSON.stringify(obj);
          // this.right=this.Newdata
        }
      });
    }
    this.oldModel.code= this.Olddata;
    this.newModel.code = this.Newdata;
    if (this.Olddata.startsWith("<") || this.Newdata.startsWith("<")) {
      this.formatType = "xml";
  } else if (this.Olddata.startsWith("{") || this.Newdata.startsWith("{")) {
      this.formatType = "json";
  }else{
      this.formatType='text/plain'
    }
    this.oldModel = Object.assign({}, this.oldModel, { language: this.formattype });
    this.newModel = Object.assign({}, this.newModel, { language: this.formattype });
    //  this.editorDIffData()
    this.showeditor = true
    this.ngxUiLoaderService.stop();
  }

  onCompareResults(diffResults: DiffResults) {
    // //console.log('diffResults', diffResults);
    this.Olddata = this.Olddata;
    this.Newdata = this.Newdata;
  }
  editorDIffData() {
    this.ngxUiLoaderService.start()
    const newContent: DiffContent = {
      leftContent: this.Olddata !== null || this.Olddata !== '' ? this.Olddata : '',
      rightContent: this.Newdata !== null || this.Newdata !== '' ? this.Newdata : '',
    };
    this.contentObservable.next(newContent);
    this.ngxUiLoaderService.stop()
  }
  constructobj(datastring, flag) {
    if(datastring['datatype']==undefined){
    if (typeof datastring == "object") {
      let obj='' ;
      // For interface context, show key-value pairs instead of just values
      if (this.context === 'interface' || this.context === 'Pipeline') {
        for (let [key, value] of Object.entries(datastring)) {
          // Skip the datatype property if it exists but wasn't set
          if (key !== 'datatype') {
            let val = typeof value === 'object' && value !== null ? JSON.stringify(value, null, 2) : (value !== null && value !== undefined ? value : '');
            obj += `${key} : ${val},\n`;
          }
        }
      } else {
        // For other contexts, show only values (original behavior - unchanged)
      for (let [key, value] of Object.entries(datastring)) {
        obj += `${value},
`
        }
      }
      if (flag == 'old') {
        this.Olddata = obj
      }
      else {
        this.Newdata = obj
      }
    } else {
      if (flag == 'old') {
        this.Olddata =datastring
      }
      else {
        this.Newdata =datastring
      }
    }
  }
  else {
    // Existing flow when datatype is defined - unchanged
    let obj = '';
    for (let [key, value] of Object.entries(datastring)) {
      // Skip the datatype property when formatting
      if (key !== 'datatype') {
      let val = this.context === 'Agent' ? JSON.stringify(value, null, 2) : value;
      obj += `${key} : ${val},\n`;
      }
    }
  
    if (this.context === 'Agent') {
      let formattedString = `{\n${obj}}`;
      if (flag === 'old') {
        this.Olddata = formattedString;
      } else {
        this.Newdata = formattedString;
      }
    } else {
      if (flag === 'old') {
        this.Olddata = obj;
      } else {
        this.Newdata = obj;
      }
    }
  }
  }  
  islinebyline:boolean;
  istogglechanged(value){
    this.islinebyline=value.checked;
      this.diffOptions=Object.assign({}, this.diffOptions, { renderSideBySide: !this.islinebyline });
  }
}
export class AuditValue {
  Key: string;
  Value: string;
}
export interface DiffResults {
  hasDiff: boolean;
  diffsCount: number;
  rowsWithDiff: {
    leftLineNumber?: number;
    rightLineNumber?: number;
    numDiffs: number;
  }[];
}
